import { useContext } from 'react';
import { NavigationHistoryContext } from './navigationHistoryContext';

export const useNavigationHistory = () => useContext(NavigationHistoryContext);
